var map = {
	"./demo-26-11-2023/LoginCard-left-old.png": "26a0",
	"./demo-26-11-2023/LoginCard-left.png": "31b8",
	"./demo-26-11-2023/LoginCard-right-old.png": "dcec",
	"./demo-26-11-2023/LoginCard-right.png": "6423",
	"./demo-26-11-2023/idigi-bull-logo-old.png": "1c8c",
	"./demo-26-11-2023/idigi-merac-logo.png": "85f3",
	"./example-bank.svg": "8149",
	"./idigi-bengkelnet.png": "c2b4",
	"./idigi-claimnet.png": "7395",
	"./idigi-insurrance-logo.png": "0082",
	"./idigi-lelangnet.png": "bc26",
	"./idigi-login-card.jpg": "fb37",
	"./idigi-surveynet.png": "6829",
	"./idigi.svg": "cc58",
	"./merac.png": "6a6f",
	"./merac.svg": "0ef2",
	"./signing.svg": "9fcb",
	"./signing_blue.svg": "86c8",
	"./ubiqu.svg": "e45d",
	"./ubiqu_white.svg": "35ca",
	"./xlinq-cropped.svg": "87aa",
	"./xlinq.svg": "efb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";